import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { defaultOrderNote } from 'shared/constants';
import { useQuoteState } from 'shared/contexts';
import { FormTextField } from 'shared/controls';
import { OrderNoteForm } from 'shared/types';
import { buildQuoteOrderNote } from 'shared/utility';

interface NewOrderNoteProps {
  userName: string;
}

export function NewOrderNote({ userName }: NewOrderNoteProps) {
  const { newOrderNoteDialogOpen, toggleNewOrderNoteDialog, setTempOrderNote } = useQuoteState();

  const methods = useForm<OrderNoteForm>({
    defaultValues: defaultOrderNote,
  });
  const { handleSubmit, reset } = methods;
  const {
    formState: { errors },
  } = useFormContext<OrderNoteForm>();

  useEffect(() => {
    reset(defaultOrderNote);
  }, [newOrderNoteDialogOpen, reset]);
  const onClose = useCallback(() => {
    toggleNewOrderNoteDialog();
  }, [toggleNewOrderNoteDialog]);

  const onSubmit = useCallback(
    (data: OrderNoteForm) => {
      const newOrderNote = buildQuoteOrderNote(data);
      newOrderNote.createdBy = userName.toUpperCase();
      newOrderNote.creationDate = new Date().toISOString();
      setTempOrderNote(newOrderNote);
      onClose();
    },
    [setTempOrderNote, userName, onClose]
  );

  return (
    <Dialog open={newOrderNoteDialogOpen} fullWidth={true} onClose={onClose}>
      <DialogTitle>Add order notes</DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <form aria-label='form' id='new-order-note-form' onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={1} pt={2}>
              <Grid xs={12} item>
                <FormTextField
                  name='note'
                  label='Notes'
                  rules={{
                    required: { message: 'Notes are required', value: true },
                  }}
                  error={Boolean(errors?.note)}
                  helperText={errors?.note?.message}
                />
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type='submit' form='new-order-note-form' color='secondary' variant='contained'>
          Add Notes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
